import OrangeButton from './OrangeButton'
import PinkButton from './PinkButton'
import generateRender from 'shared/utils/generateRender';

const BonusLinkButton = generateRender({
  default: OrangeButton,
  ti: PinkButton,
  hri: PinkButton,
})

export default BonusLinkButton;
